import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { filter, map, head, isEmpty, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { ApiToken_Token, ApiToken_Filiale, ApiToken_Filiale_$reflection, ApiToken_CreateTokenResult_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { int32_type, list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import * as react from "react";
import { HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Model, Msg, Model_get_Init } from "./Types.fs.js";
import { errorCmd, request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { GlobalMessageBox, OkButton, GlobalMessageType, Remote$1, GlobalMsg, GlobalMessageBox_ConfirmationBox } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { some } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export function Http_createToken(filialeId) {
    const response = fetch(`/api/apitoken/create/${filialeId}`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(ApiToken_CreateTokenResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getFilialen() {
    const response = fetch("api/apitoken", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(ApiToken_Filiale_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_deleteToken(id) {
    const response = fetch(`/api/apitoken/${id}`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), singleton(new Types_RequestProperties(0, ["DELETE"]))), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(int32_type, new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0] | 0;
                }
            });
        }
    });
}

function State_msgBoxBodyElement(tokenValue) {
    let children_2, s_1, children_10, children_4, props_4, children_8;
    const children_12 = [react.createElement("p", {}, "Es wurde ein neues API-Token erstellt."), (children_2 = [(s_1 = "Dieses API-Token müssen Sie nun der Anwendung, die auf Ihr BFS-Konto zugreifen soll, zur Verfügung stellen. ", s_1), "Kopieren Sie das API-Token bitte jetzt. Ein späteres Auslesen ist nicht mehr möglich."], react.createElement("p", {}, ...children_2)), (children_10 = [(children_4 = [(props_4 = [new HTMLAttr(65, ["input"]), new HTMLAttr(132, [true]), new HTMLAttr(161, [tokenValue]), ["style", {
        minWidth: "500px",
    }]], react.createElement("input", keyValueList(props_4, 1)))], react.createElement("div", {
        className: "control",
    }, ...children_4)), (children_8 = [react.createElement("a", {
        className: "button is-info",
        onClick: (_arg) => {
            navigator.clipboard.writeText(tokenValue);
        },
    }, "Kopieren")], react.createElement("div", {
        className: "control",
    }, ...children_8))], react.createElement("div", {
        className: "field has-addons",
    }, ...children_10))];
    return react.createElement("div", {
        className: "paragraphs",
    }, ...children_12);
}

export function State_init(page, user, lastModel) {
    return [Model_get_Init(), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let matchValue, matchValue_1;
    switch (msg.tag) {
        case 1: {
            const selectedFiliale = (msg.fields[0].tag === 0) ? (!isEmpty(msg.fields[0].fields[0]) ? head(msg.fields[0].fields[0]).Id : undefined) : undefined;
            return [new Model(Loaded(msg.fields[0]), selectedFiliale), Cmd_none()];
        }
        case 2:
            return [new Model(model.Filialen, msg.fields[0]), Cmd_none()];
        case 3: {
            const msg_1 = new Msg(8, [new GlobalMsg(3, [GlobalMessageBox_ConfirmationBox("API-Token löschen", toText(printf("Soll das API-Token wirklich gelöscht werden?\n\nDie Anwendung, die dieses API-Token derzeit verwendet, kann dann nicht mehr auf Ihr BFS-Konto zugreifen.")), some(new Msg(4, [msg.fields[0]])))])]);
            return [model, singleton((dispatch) => {
                dispatch(msg_1);
            })];
        }
        case 4:
            return [model, request(Http_deleteToken, msg.fields[0], (Item_3) => (new Msg(5, [Item_3])))];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [model, errorCmd((Item_5) => (new Msg(8, [Item_5])), "Löschen", msg.fields[0].fields[0])];
            }
            else {
                return [new Model((matchValue = model.Filialen, (matchValue.tag === 3) ? (new Remote$1(3, [map((f_1) => (new ApiToken_Filiale(f_1.Id, f_1.Name, f_1.IsZentrale, filter((t) => (t.Id !== msg.fields[0].fields[0]), f_1.Tokens))), matchValue.fields[0])])) : model.Filialen), model.SelectedFiliale), Cmd_none()];
            }
        case 6:
            return [model, request(Http_createToken, msg.fields[0], (Item_6) => (new Msg(7, [Item_6])))];
        case 7:
            if (msg.fields[0].tag === 1) {
                return [model, errorCmd((Item_8) => (new Msg(8, [Item_8])), "Tokenerstellen", msg.fields[0].fields[0])];
            }
            else {
                const tokenToAdd = new ApiToken_Token(msg.fields[0].fields[0].Id, msg.fields[0].fields[0].Erstellt, undefined);
                const model$0027_4 = new Model((matchValue_1 = model.Filialen, (matchValue_1.tag === 3) ? (new Remote$1(3, [map((f_2) => (new ApiToken_Filiale(f_2.Id, f_2.Name, f_2.IsZentrale, (f_2.Id === msg.fields[0].fields[0].FilialeId) ? append(singleton(tokenToAdd), f_2.Tokens) : f_2.Tokens)), matchValue_1.fields[0])])) : model.Filialen), model.SelectedFiliale);
                const messageBox = new GlobalMessageBox(new GlobalMessageType(1, []), "Neues Token erstellt", State_msgBoxBodyElement(msg.fields[0].fields[0].Value), singleton(OkButton(undefined)));
                return [model$0027_4, singleton((dispatch_1) => {
                    dispatch_1(new Msg(8, [new GlobalMsg(3, [messageBox])]));
                })];
            }
        case 8:
            throw new Error("Not Implemented");
        default:
            return [new Model(new Remote$1(1, []), model.SelectedFiliale), request(Http_getFilialen, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
